import { Component, OnInit, Input, Output, EventEmitter, ViewChild, HostListener } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { AddincometypeComponent } from '../../incometype/addincometype/addincometype.component';
import { AddpartyComponent } from '../../party/addparty/addparty.component';
import { ComponentCanDeactivate } from '../../PendingChangesGuard';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
  selector: 'app-addsubledger',
  templateUrl: './addsubledger.component.html',
  styleUrls: ['./addsubledger.component.css']
})
export class AddsubledgerComponent implements OnInit{

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  saveloading: boolean;
  //Save Validation
  submitted: boolean;
  successfully: boolean;

  accountid: any = []

  subledgerdetailsColl: any = [];
  //Edit Get Values
  subledgerColl: any = [];
  subledgertypeColl: any = [];

  subledgerform = new FormGroup({
    subledgerid: new FormControl(null),
    subledgername: new FormControl('', Validators.required),
    subledgertypeid: new FormControl(null, Validators.required),   
    subledgercode: new FormControl(null),   
    inactive: new FormControl(false),
  });

  isstaff: boolean = false
  
  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Subledger";

  @Input() subledgerid: number = 0
  @Input() subledgername: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,private datePipe: DatePipe,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.subledgerid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {

        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }         
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }         
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  ngAfterViewInit(){
 
    this.loginService.fnSetFirstControlFocus('subledgername');
  }
  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.subledgerform.reset();
      this.fnInitializeSubledger();

      if (this.subledgerid > 0) {
        this.fngetSubledger();
      }
      this.fngetSubledgerType()
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.subledgerid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }
    //this.isadjtypeaddmode = this.loginService.fnCheckUserRoleAction("AdjType", 'CREATE')
    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeSubledger() {
    this.subledgerform.setValue({

      subledgerid: 0,
      subledgername: '',
      subledgertypeid: null,     
      subledgercode:null,    
      inactive: false,
    })
  }

  fngetSubledgerType() {

    var data = {
      'subledgertypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getSubledgerTypeListview(data)
      .subscribe(
        (res) => {

          if (res.json().status == 200) {
            this.subledgertypeColl = res.json().result;

          }
          else if (res.json().status == 400) {
            this.toastr.error('Error', res.json().err_field);
          }


        },
        (err) => {

          this.toastr.error('Error', err);
        })
  }


  //Get 
  fngetSubledger() {
   
    var data = {
      'subledgerid': this.subledgerid,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getSubledger(data)
      .subscribe(
        (res) => {
          this.subledgerColl = res.json().result;
          var editdata = this.subledgerColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {
 
    try {
    
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.subledgerform.valid) {
        this.saveloading = true;
        //Check
        var data = {
          'subledgerid': this.subledgerid,
          'subledgername': this.subledgerform.get('subledgername').value,
          'subledgertypeid': this.subledgerform.get('subledgertypeid').value,        
          'subledgercode': this.subledgerform.get('subledgercode').value,         
          'companyid': this.loginService.fnGetCompanyId(),
          'organizationid': this.loginService.fnGetOrganizationId(),
          'inactive': this.subledgerform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }
      
        this.appService.fnCheckSubledger(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.subledgerform.get('subledgerid').value > 0) {
                //Update Department
                this.fnSetSubledger(data);
              }
              else {
                //Insert Department
                this.fnInsertSubledger(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading = false;
                this.subledgerform.controls['subledgername'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading = false;
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertSubledger(data) {
  
    this.appService.fnInsertSubledger(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {

          var result = res.json().result;

          var rtnsubledgerid = 0;
          if (result.length > 0) {
            rtnsubledgerid = result[0].subledgerid
           
          }
          this.toastr.success('', "The new subledger has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.subledgerid);

          this.emitData.emit(rtnsubledgerid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetSubledger(data) {

    this.appService.fnSetSubledger(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {
          this.toastr.success('', "The subledger has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.subledgerid, data.subledgername);

          this.emitData.emit(this.subledgerid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.subledgerform.setValue({

      subledgerid: deptBO.subledgerid,
      subledgername: deptBO.subledgername,
      subledgertypeid: deptBO.subledgertypeid,     
      subledgercode: deptBO.subledgercode,      
      inactive: deptBO.inactive,
    });

    if (deptBO.subledgertypename === 'Staff') {
      this.isstaff = true;
    }

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }
 fnCheckStaff() {
    this.isstaff = false

    for (let abo of this.subledgertypeColl) {
      if (abo.subledgertypeid === this.subledgerform.get("subledgertypeid").value) {
        if (abo.subledgertypename === 'Staff') {
          this.isstaff = true;
        }
      }
    }
  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }

  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


       this.appService.fnInsertActivity(data).subscribe(
         (res)=>{
         },
         (err)=>{

         });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}

